// Pheromones Theme JavaScript

(function() {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('DOMContentLoaded', function() {
    const navTrigger = document.querySelector('.nav-trigger');
    if (navTrigger) {
      navTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.add('nav-active');
      });
    }

    const menu = document.querySelector('.menu');
    if (menu) {
      menu.addEventListener('click', function(e) {
        const isLink = e.target.closest('a');
        if (!isLink) {
          document.body.classList.remove('nav-active');
        }
      });
    }
  });

  // Product tabs functionality
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tabs-list li');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) {
          t.classList.remove('active-tab-li');
        });
        tab.classList.add('active-tab-li');

        const tabContent = document.querySelector(`[data-tab="${tab.dataset.tab}"]`);
        const tabDetails = document.querySelectorAll('.tab-details');
        tabDetails.forEach(function(tabDetail) {
          tabDetail.classList.remove('active-tab-content');
        });

        document.querySelectorAll('.tab-details').forEach(function(tabDetail) {
          if (tabDetail.dataset.tab === tab.dataset.tab) {
            tabDetail.classList.add('active-tab-content');
          }
        });
      });
    });
  });

  // FAQ accordion functionality
  document.addEventListener('DOMContentLoaded', function() {
    const faqQuestions = document.querySelectorAll('.faq-item-question');
    faqQuestions.forEach(function(question) {
      question.addEventListener('click', function() {
        const parentItem = question.closest('.faq-item');
        if (!parentItem) return;

        const isCurrentlyActive = parentItem.classList.contains('active');

        document.querySelectorAll('.faq-item').forEach(function(item) {
          item.classList.remove('active');
        });

        if (!isCurrentlyActive) {
          parentItem.classList.add('active');
        }
      });
    });

    // FAQ style 2
    const faqQuestions2 = document.querySelectorAll('.faq-item-2-question');
    faqQuestions2.forEach(function(question) {
      question.addEventListener('click', function() {
        const parentItem = question.closest('.faq-item-2');
        if (parentItem) {
          parentItem.classList.toggle('active');
        }
      });
    });
  });


  // // Hero carousel rotation
  // document.addEventListener('DOMContentLoaded', function() {
  //   const heroSlider = document.querySelector('.hero-carousel-slider');
  //   if (heroSlider) {
  //     let rotation = 48;
  //     let isPaused = false;

  //     function animate() {
  //       if (!isPaused) {
  //         rotation += 0.1;
  //       }
  //       heroSlider.style.transform = `perspective(600px) rotateY(${rotation}deg)`;
  //       heroSlider.style.willChange = 'transform';
  //       requestAnimationFrame(animate);
  //     }

  //     animate();

  //     const heroWrapper = document.querySelector('.hero-carousel-wrapper');
  //     if (heroWrapper) {
  //       heroWrapper.addEventListener('mouseenter', () => isPaused = true);
  //       heroWrapper.addEventListener('mouseleave', () => isPaused = false);
  //     }
  //   }
  // });

})();


/* ------------------------------------------------------------------
   CART SYNC  (added 2026-08-26, L88 step 6)

   Keeps the cart drawer and header cart count in step when something
   OUTSIDE this theme adds to the cart through Shopify's AJAX Cart API.

   Why: the RevenueHunt quiz adds items with /cart/add.js. The item is
   genuinely added and appears at checkout, but this theme renders the
   cart drawer server side at page load and never re-renders it, so the
   drawer kept reading as empty until the visitor reloaded. That looked
   broken, and risked people adding the same bottle several times because
   nothing appeared to happen.

   How: watch fetch and XHR for successful POSTs to the cart endpoints,
   then re-fetch /cart, lift the freshly rendered drawer markup out of
   that response, and swap it in. Same Liquid, same translations, no
   second copy of the markup to keep in sync.

   To remove: delete this block. Nothing else depends on it.
   ------------------------------------------------------------------ */
(function(){
  'use strict';

  var RE  = /\/cart\/(add|change|update|clear)/;
  var ADD = /\/cart\/add/;
  var busy = false;

  function sync(openAfter){
    if (busy) return;
    busy = true;
    fetch('/cart', { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var fresh = doc.getElementById('cart-drawer-items');
        var live  = document.getElementById('cart-drawer-items');
        if (fresh && live) live.innerHTML = fresh.innerHTML;

        var t1 = doc.querySelector('.cart-drawer__total-price');
        var t2 = document.querySelector('.cart-drawer__total-price');
        if (t1 && t2) t2.textContent = t1.textContent;

        var c1 = doc.querySelector('.cart-count');
        if (c1) {
          var n = c1.textContent.trim();
          var hide = (n === '' || n === '0');
          document.querySelectorAll('.cart-count').forEach(function(el){
            el.textContent = n;
            el.style.display = hide ? 'none' : '';
          });
        }

        if (openAfter && typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
      })
      .catch(function(e){ console.warn('cart-sync failed', e); })
      .then(function(){ busy = false; });
  }

  window.refreshCartDrawer = sync;

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : ((input && input.url) || '');
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var call = nativeFetch.apply(this, arguments);
      if (method === 'POST' && RE.test(url)) {
        call.then(function(res){
          if (res && res.ok) setTimeout(function(){ sync(ADD.test(url)); }, 80);
        }).catch(function(){});
      }
      return call;
    };
  }

  var xopen = XMLHttpRequest.prototype.open;
  var xsend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url){
    this._cartSync = { m: String(method || '').toUpperCase(), u: String(url || '') };
    return xopen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(){
    var meta = this._cartSync;
    if (meta && meta.m === 'POST' && RE.test(meta.u)) {
      this.addEventListener('load', function(){
        if (this.status >= 200 && this.status < 300) {
          setTimeout(function(){ sync(ADD.test(meta.u)); }, 80);
        }
      });
    }
    return xsend.apply(this, arguments);
  };
})();